@if (viewStyle === 'rectangular-primary') {
  <div
    class="rectangular-primary"
    [ngClass]="{ 'has-image-uploaded': image }"
    appDragDropFileUpload
    (fileDropped)="setImage($any($event))"
  >
    <input
      [disabled]="isLoading"
      hidden
      type="file"
      accept="image/jpeg, image/png"
      (change)="setImage($any($event).target.files)"
      #fileInput
    />

    <!-- IMAGE = FALSE - Show add image box -->
    <div class="input-image-placeholder" *ngIf="!image">
      <app-icon
        [iconName]="'add_photo_alternate'"
        width="70px"
        height="70px"
      ></app-icon>

      <div class="my-25px text-center">
        <p class="mb-10px">{{ 'GENERAL.DROP_IMAGE' | translate }}</p>

        @if (!disabled) {
          <app-button
            size="small"
            color="secondary-outlined-white"
            (clicked)="fileInput.click()"
          >
            {{ 'GENERAL.BROWSE' | translate }}
          </app-button>
        }
      </div>

      <div class="requirements">
        <small *ngIf="minWidth || minHeight">
          {{ 'GENERAL.MINIMUM_REQUIREMENTS' | translate }}
          <ng-container *ngIf="minWidth"
            >{{ minWidth }}
            {{ 'GENERAL.MIN_WIDTH_PIXELS' | translate }}</ng-container
          >
          <ng-container *ngIf="minWidth && minHeight">
            {{ 'GENERAL.AND' | translate }}
          </ng-container>

          <ng-container *ngIf="minHeight"
            >{{ minHeight }}
            {{ 'GENERAL.MIN_HEIGHT_PIXELS' | translate }}</ng-container
          >
        </small>

        <small>{{ 'GENERAL.IMAGE_SUPPORT' | translate }}</small>
      </div>
    </div>

    <!-- Upload loading overlay -->
    <div class="upload-overlay" *ngIf="isLoading">
      <div class="upload-overlay__spinner"></div>
      <span class="upload-overlay__label">{{ 'POSTS.UPLOADING_IMAGE' | translate }}</span>
    </div>

    <!-- IMAGE = TRUE - Image preview -->
    <div class="image-preview" *ngIf="!!image">
      <div class="image-wrapper">
        <img [src]="image" alt="your photo" />
      </div>

      <div class="image-actions">
        @if (!disabled) {
          <app-button
            class="replace-button"
            (clicked)="fileInput.click()"
            size="small"
            color="primary"
            [isIcon]="true"
            matTooltip="Replace Image"
          >
            <app-icon
              [iconName]="'replace'"
              [width]="'20px'"
              [height]="'auto'"
              [fillPathColor]="'white'"
            ></app-icon>
          </app-button>

          @if (!hideDeleteButton) {
            <app-button
              class="delete-button"
              (clicked)="removePhoto()"
              size="small"
              color="black"
              [isIcon]="true"
              matTooltip="Delete Image"
            >
              <app-icon
                [iconName]="'delete-new'"
                [width]="'18px'"
                [height]="'auto'"
              ></app-icon>
            </app-button>
          }
        }
      </div>
    </div>
  </div>
}

@if (viewStyle === 'icon-uploader') {
  <div class="icon-uploader">
    <div class="icon-preview">
      <app-text [tag]="'h5'" [weight]="'bold'">{{
        'GENERAL.ICON' | translate
      }}</app-text>
      @if (image) {
        <img [src]="image" alt="Icon" />
      } @else {
        <app-text [tag]="'p'">{{
          'GENERAL.ICON_SELECTED' | translate
        }}</app-text>
      }
    </div>

    <app-button
      (clicked)="fileInput.click()"
      size="medium"
      color="secondary-outlined-white"
    >
      @if (image) {
        Change Icon
      } @else {
        Select Icon
      }
    </app-button>

    <input
      [disabled]="isLoading"
      hidden
      type="file"
      accept="image/jpeg, image/png"
      (change)="setImage($any($event).target.files)"
      #fileInput
    />

    <div class="requirements">
      <small>{{ 'GENERAL.PHOTO_PIXELS_REQUIREMENTS' | translate }}</small>
      <small>{{ 'GENERAL.IMAGE_SUPPORT' | translate }}</small>
    </div>
  </div>
}
